import React, { Component } from "react";
import classes from "./IdentificationChooser.module.sass";
import Button from "../ui/Button/Button";

class IdentificationChooser extends Component {

  render() {
    return (
      <div className={classes.identificationChooser}>
        <div className={classes.listButtons}>
          <Button
            onClick={() => this.props.identifierClicked(identifierType.CPF)}
            selected={this.props.selectedIdentifier === identifierType.CPF}
            disabled={this.props.ibc && this.props.ibcType !== '1'}
          >
            Pessoa Física
          </Button>
          <Button
            onClick={() => this.props.identifierClicked(identifierType.CNPJ)}
            selected={this.props.selectedIdentifier === identifierType.CNPJ}
            disabled={this.props.ibc && this.props.ibcType === '1'}
          >
            Pessoa Jurídica
          </Button>
        </div>
      </div>
    );
  }
}

export const identifierType = {
  CPF: "cpf",
  CNPJ: "cnpj"
};

export default IdentificationChooser;
